/**
 * This utility class permits the abstraction of methods
 * for reuse
 */
import { config } from "../../config/env";
import { AttributeIconMap } from '@gamma/shared/icons';

/**
   *
   * @param {The type of the enum - like GENDER or PARTY} enumType
   * @param {The Key to the enum you are looking-up} entryKey
   * @returns The usable path and filename of the image found or <undefined>
   */
export default function getCharacteristicsImagePath(enumType, entryKey) {
    let useablePath;

    // Dataset-specific attributes (Group, PersonType, Dataset, House, USCParty) are not in shared constants
    // They're handled separately through dataset metadata - skip silently
    const datasetSpecificTypes = ['Group', 'PersonType', 'Dataset', 'House', 'USCParty'];
    if (datasetSpecificTypes.includes(enumType)) {
      return useablePath; // undefined - caller should handle dataset-specific icons separately
    }

    try {
      if (!AttributeIconMap[enumType]) {
        return useablePath;
      }

      const relativePath = AttributeIconMap[enumType][entryKey];

      if (!relativePath) {
        return useablePath;
      }

      useablePath = config.publicUrl + relativePath;
    } catch (error) {
      console.error(`[ImageService] ❌ Error loading icon for "${enumType}.${entryKey}":`, error);
    }

    return useablePath;
  }

  /**
   * 
   * @param {The type of the enum - like GENDER or PARTY} enumType 
   * @param {The Key to the enum you are looking-up} entryKey
   * @returns Boolean
   */
  export function imagePathValid(enumType,entryKey){
    const path = getCharacteristicsImagePath(enumType,entryKey);
    const b  = path !== 'undefined';
    return b;
  }

  /**
   * 
   * @param {A url String} url 
   * @returns Boolean 
   * if url is valid construct but does not check existance
   */
  export function validUrl(url) {
    return /http(s)?:\/\/(\w+:?\w*@)?(\S+)(:\d+)?((?<=\.)\w+)+(\/([\w#!:.?+=&%@!\-/])*)?/gi.test(url);
  }
  
  